<template lang="pug">
    .index
        img(src="../imgs/bg-404.svg")
        router-link(to='/')
            el-button 您所访问的页面不存在，点击回首页
</template>

<script>
export default {
    name: 'Error404',
    data() {
        return {};
    },
    created() {
        console.log('created');
    },
    mounted() {},
};
</script>

<style lang="stylus" scoped>
.index
    display flex
    flex-direction column
    justify-content center
    align-items center
    width 100%
    img
        width 500px
        opacity .8
</style>
